import React from 'react';
import FooterMenuItem from './FooterMenuItem';

interface MenuItem {
	href: string;
	title?: string;
	name?: string;
}

interface FooterMenuListProps {
	items?: MenuItem[];
}

const FooterMenuList: React.FC<FooterMenuListProps> = ({items}) => {
	if (!items || items.length === 0) {
		return null;
	}

	return (
		<>
			{items.map((item) => (
				<FooterMenuItem key={item.href} href={item.href}>
					{item.title || item.name}
				</FooterMenuItem>
			))}
		</>
	);
};

export default FooterMenuList;

